import { render, staticRenderFns } from "./metrics.vue?vue&type=template&id=72a57ce5&scoped=true"
import script from "./metrics.vue?vue&type=script&lang=js"
export * from "./metrics.vue?vue&type=script&lang=js"
import style0 from "./metrics.vue?vue&type=style&index=0&id=72a57ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a57ce5",
  null
  
)

export default component.exports